import { FC } from 'react';
import {
  AuthHeadingImageTypeEnums,
  imagesObj,
  stylesLineObj,
  stylesObj,
  stylesObjMobile,
} from 'view/pages/auth/helpers';
import ImageLine from 'assets/images/heading_line.svg';
import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme';
import * as S from './styled';

type AuthHeadingImageType =
  (typeof AuthHeadingImageTypeEnums)[keyof typeof AuthHeadingImageTypeEnums];

interface IAuthHeadingProps {
  title: string;
  imageType: AuthHeadingImageType;
  subTitle?: string;
}

const AuthHeading: FC<IAuthHeadingProps> = ({ title, subTitle = '', imageType = 'circle' }) => {
  const matches = useMediaQuery(theme.breakpoints.down('tablet'));
  const [firstWordCircle, ...restCircleWords] = title.split(' ');
  const wordsArray = title.split(' ');
  const restWordsLine = wordsArray.slice(0, -1);
  const lastLineWord = wordsArray[wordsArray.length - 1];

  return (
    <S.AuthHeadingBox>
      {imageType === 'circle' ? (
        <S.Title component="h2">
          <S.TitleCircle component="span">
            {firstWordCircle}{' '}
            <img
              src={imagesObj[firstWordCircle].imageUrl}
              alt="Heading"
              style={matches ? stylesObjMobile[firstWordCircle] : stylesObj[firstWordCircle]}
            />{' '}
          </S.TitleCircle>{' '}
          {restCircleWords.join(' ')}
        </S.Title>
      ) : (
        <S.Title component="h2">
          {restWordsLine.join(' ')}{' '}
          <S.TitleCircle component="span">
            {lastLineWord} <img src={ImageLine} alt="Heading" style={stylesLineObj} />{' '}
          </S.TitleCircle>
        </S.Title>
      )}
      {subTitle && <S.SubTitle component="p">{subTitle}</S.SubTitle>}
    </S.AuthHeadingBox>
  );
};

export default AuthHeading;
